export function downloadFile(fileName, data, uid, elementName) {
    const downloadLink = document.createElement('a');
    let newFilename = fileName;
    const auxNames = fileName.split('_');
    if (uid && elementName && auxNames.length > 2) {
        const piLastName = auxNames[1];
        const lastDot = fileName.lastIndexOf('.');
        const ext = lastDot !== -1 ? fileName.substring(lastDot) : '.pdf';
        newFilename = `${uid.trim()}_${piLastName.trim()}_${elementName.trim()}${ext}`;
    }
    const url = URL.createObjectURL(data);
    downloadLink.href = url;
    downloadLink.download = newFilename;
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
